import styled, { css } from 'styled-components';
import { shouldIgnoreProp } from '../../utils/shouldIgnoreProp';
import { Box } from './Box';

interface TranslateBoxProps {
    trigger: boolean;
    x1?: number;
    y1?: number;
    x2?: number;
    y2?: number;
}

export const TranslateBox = styled(Box)
    .withConfig({
        shouldForwardProp: shouldIgnoreProp('trigger'),
    })
    .attrs((props) => props)<TranslateBoxProps>`
    ${({ trigger, x1 = 0, y1 = 0, x2 = 0, y2 = 0 }: TranslateBoxProps) =>
        trigger
            ? css`
                  transform: translate(${x2}px, ${y2}px);
              `
            : css`
                  transform: translate(${x1}px, ${y1}px);
              `}
`;
